import React from 'react';

import { FFSlider } from '../FFSlider/FFSlider';

export type PreferredWeeklyHoursSliderProps = {
  name?: string;
  maxWeeklyHours: number;
  currentValue: number;
  onValueChange: (value: number) => void;
};

export const PreferredWeeklyHoursSlider = ({
  name = 'PREFERRED_WEEKLY_HOURS_SLIDER',
  maxWeeklyHours,
  currentValue,
  onValueChange,
}: PreferredWeeklyHoursSliderProps) => {
  return (
    <div data-test={name}>
      <FFSlider
        input={
          {
            value: currentValue,
            onChange: () => {},
          } as { value: number }
        }
        minRange={{ value: 0, label: '0' }}
        maxRange={{
          value: maxWeeklyHours,
          label: `${maxWeeklyHours}`,
        }}
        onValueChange={onValueChange}
      />
    </div>
  );
};
